import styled, { css } from 'styled-components';
import { Paper } from '@material-ui/core';

const FlexBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export default {
  Paper: styled(Paper)`
    ${({ theme }) => css`
      padding: 1rem 1.25rem;

      ${theme.breakpoints.up('sm')} {
        padding: 1.375rem;
      }

      & .PanelTitle-typography {
        padding-left: 1rem;
        font-size: 1rem;
        color: ${theme.palette.background.dark.main};

        &.MuiTypography-colorSecondary {
          color: ${theme.palette.secondary.main};
        }
      }
    `}
  `,

  PanelActions: styled.div`
    padding-left: 1rem;
    margin: -7px;
  `,

  PanelTitle: styled(FlexBox)`
    justify-content: flex-start;
  `,

  PanelTop: styled(FlexBox)`
    margin-bottom: 0.75rem;

    ${({ $noChildren }) =>
      $noChildren &&
      css`
        margin-bottom: 0;
      `}
  `,

  PanelIcon: styled.span`
    & .MuiIcon-fontSizeLarge {
      font-size: 1.5rem;
      width: 1.5rem;

      ${({ theme }) => css`
        color: ${theme.palette.background.dark.main};
      `}
    }
  `,

  PanelChildren: styled.div`
    ${({ theme }) => css`
      ${theme.breakpoints.up('sm')} {
        padding-left: 2.5rem;
        padding-right: 2.5rem;
      }
    `}
  `,

  FlexBox,
};
